import { KpiIcon } from "./KpiIcons";
import KpiCascadeFilter from "./KpiTagFilter";

const KpiFiltersBar = ({
  search = "",
  onSearchChange,
  moduleFilter = "",
  onModuleChange,
  fyFilter = "",
  onFyChange,
  frameworkFilter = "",
  onFrameworkChange,
  financialYears = [],
  modules = [],
  frameworks = [],
  locations = [],
  advFilterCount = 0,
  onOpenAdvanced,
  onClearAll,
  // ── Cascade tag filter ──────────────────────────────────
  kpiList = [],           // full kpiList (items must have .rawTags)
  filterSteps = [],       // [{ key: string, values: Set }]
  onFilterStepsChange,
  lockedSteps   // (newSteps) => void
}) => {
  const hasAny =
    search ||
    moduleFilter ||
    fyFilter ||
    frameworkFilter ||
    advFilterCount > 0 ||
    filterSteps.some((s) => s.values?.size > 0);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 0,
        borderBottom: "1px solid var(--rule-2)",
        background: "var(--surface)",
      }}
    >
      {/* ── Row 1: quick filters ── */}
      <div
        style={{
          display: "flex",
          gap: 8,
          alignItems: "center",
          flexWrap: "wrap",
          padding: "12px 24px 10px",
          borderBottom: "1px solid #f3f4f6",
        }}
      >
        {/* Search */}
        <div style={{ position: "relative", flex: "1 1 200px", minWidth: 160, maxWidth: 300 }}>
          <div style={{ position: "absolute", left: 11, top: "50%", transform: "translateY(-50%)", color: "var(--ink-4)", pointerEvents: "none" }}>
            <KpiIcon name="search" size={14} />
          </div>
          <input
            className="kpi-input"
            style={{ paddingLeft: 34, paddingRight: search ? 32 : 12 }}
            placeholder="Search KPI title…"
            value={search}
            onChange={(e) => onSearchChange?.(e.target.value)}
          />
          {search && (
            <button
              type="button"
              onClick={() => onSearchChange?.("")}
              style={{
                position: "absolute", right: 10, top: "50%", transform: "translateY(-50%)",
                border: "none", background: "transparent", cursor: "pointer",
                fontSize: 18, color: "var(--ink-4)", lineHeight: 1, padding: 0,
              }}
            >
              ×
            </button>
          )}
        </div>

        <div style={{ width: 1, height: 26, background: "var(--rule)", flexShrink: 0 }} />



        {/* Financial Year */}
        <select
          className={`kpi-inline-select${fyFilter ? " active" : ""}`}
          value={fyFilter}
          onChange={(e) => onFyChange?.(e.target.value)}
          title="Filter by Financial Year"
        >
          <option value="">All Years</option>
          {financialYears.map((fy) => (
            <option key={fy.id} value={fy.id}>{fy.financial_year_value || fy.name}</option>
          ))}
        </select>

        {/* Framework */}
        <select
          className={`kpi-inline-select${frameworkFilter ? " active" : ""}`}
          value={frameworkFilter}
          onChange={(e) => onFrameworkChange?.(e.target.value)}
          title="Filter by Framework"
        >
          <option value="">All Frameworks</option>
          {frameworks?.map((f) => <option key={f?.id} value={f?.id}>{f?.display_name}</option>)}
        </select>

        <div style={{ width: 1, height: 26, background: "var(--rule)", flexShrink: 0 }} />

        {/* Advanced Filters button */}
        <button
          type="button"
          onClick={onOpenAdvanced}
          style={{
            display: "flex", alignItems: "center", gap: 7,
            padding: "7px 13px",
            border: `1.5px solid ${advFilterCount > 0 ? "var(--accent)" : "var(--rule)"}`,
            borderRadius: 8,
            background: advFilterCount > 0 ? "var(--accent-3)" : "var(--surface)",
            color: advFilterCount > 0 ? "var(--accent)" : "var(--ink-2)",
            fontWeight: 700, fontSize: 12.5, fontFamily: "var(--font-sans)",
            cursor: "pointer", transition: "all 0.15s", whiteSpace: "nowrap", height: 36,
          }}
        >
          <KpiIcon name="filter" size={13} />
          Filters
          {advFilterCount > 0 && (
            <span style={{
              background: "var(--accent)", color: "#fff",
              fontSize: 10, fontWeight: 700, padding: "1px 6px",
              borderRadius: 20, lineHeight: "16px",
            }}>
              {advFilterCount}
            </span>
          )}
        </button>

        {/* Clear all */}
        {hasAny && (
          <button
            type="button"
            onClick={onClearAll}
            style={{
              padding: "6px 12px", border: "1.5px solid var(--rule)",
              borderRadius: 8, background: "transparent", cursor: "pointer",
              fontSize: 11.5, fontWeight: 700, color: "var(--ink-3)",
              fontFamily: "var(--font-sans)", whiteSpace: "nowrap",
              transition: "all 0.15s", height: 36,
            }}
          >
            Clear all
          </button>
        )}
      </div>

      {/* ── Row 2: Cascade tag filter ── */}
      <div style={{ padding: "8px 24px 10px" }}>
        <KpiCascadeFilter
          kpiList={kpiList}
          filterSteps={filterSteps}
          onFilterStepsChange={onFilterStepsChange}
          lockedSteps={lockedSteps || []}
        />
      </div>
    </div>
  );
};

export default KpiFiltersBar;